type ExportFormatConfig = {
    encoding: "utf8" | "sjis";
    encodingLock: boolean;
    bom: boolean;
    delimiter: string;
    headers: string[];
    mapping: Record<string, string>;
    type: "csv" | "xml";
    forceQuote?: boolean;
};

export const exportFormats: Record<string, ExportFormatConfig> = {

    standard: {
        encoding: "utf8",
        encodingLock: false,
        bom: false,
        delimiter: ",",
        headers: [
            "id",
            "phone",
            "email",
            "category",
            "contactType",
            "contactName",
            "firstName",
            "lastName",
            "firstNameKana",
            "lastNameKana",
            "organization",
            "department",
            "position",
            "mobilePhone",
            "telExtension",
            "altEmail",
            "fax",
            "postalCode",
            "address1",
            "address2",
            "city",
            "prefecture",
            "country",
            "site",
            "linkedIn",
            "facebook",
            "twitter",
            "skype",
            "slack",
            "github",
            "youtube",
            "tiktok",
            "spotify",
            "discord",
            "isFavorite",
            "birthday",
            "memo",
            "profileImage",
            "mimeType",
            "createdDate",
            "updatedDate",
        ],
        mapping: {
            id: "id",
            phone: "phone",
            email: "email",
            category: "category",
            contactType: "contactType",
            contactName: "contactName",
            firstName: "firstName",
            lastName: "lastName",
            firstNameKana: "firstNameKana",
            lastNameKana: "lastNameKana",
            organization: "organization",
            department: "department",
            position: "position",
            mobilePhone: "mobilePhone",
            telExtension: "telExtension",
            altEmail: "altEmail",
            fax: "fax",
            postalCode: "postalCode",
            address1: "address1",
            address2: "address2",
            city: "city",
            prefecture: "prefecture",
            country: "country",
            site: "site",
            linkedIn: "linkedIn",
            facebook: "facebook",
            twitter: "twitter",
            skype: "skype",
            slack: "slack",
            github: "github",
            youtube: "youtube",
            tiktok: "tiktok",
            spotify: "spotify",
            discord: "discord",
            isFavorite: "isFavorite",
            birthday: "birthday",
            memo: "memo",
            profileImage: "profileImage",
            mimeType: "mimeType",
            createdDate: "createdDate",
            updatedDate: "updatedDate",
        },
        type: "csv",
    },

    yealink: {
        encoding: "utf8",
        encodingLock: false,
        bom: true,
        delimiter: ",",
        headers: [
            "display_name",
            "office_number",
            "mobile_number",
            "other_number",
        ],
        mapping: {
            display_name: "fullName",
            office_number: "mobilePhone",
            mobile_number: "phone",
            other_number: "telExtension",
        },
        type: "csv",
    },

    cloudbiz: {
        encoding: "utf8",
        encodingLock: false,
        bom: true,
        delimiter: ",",
        headers: [
            "名称",
            "名称カナ",
            "短縮番号",
            "ワンタッチ番号",
            "内線/外線",
            "電話番号",
            "備考",
        ],
        mapping: {
            "名称": "fullName",
            "名称カナ": "kanaFull",
            "短縮番号": "shortNumber",
            "ワンタッチ番号": "oneTouchNumber",
            "内線/外線": "lineType",
            "電話番号": "phone",
            "備考": "memo",
        },
        forceQuote: true,
        type: "csv",
    },
};